import * as React from 'react';
import isNil from 'lodash/isNil';

import ContentCardStatsHeader from '../header/ContentCardStatsHeader';
import ContentCardStatsRow from '../row/ContentCardStatsRow';

import { __t, applyTranslations } from 'utils/language';
import { abbrNum } from 'utils/helper/common';
import { getCountMetric, getRateMetric } from 'utils/metrics';
import { renderPrice } from 'utils/helper/price';

import type { StatisticsCountry } from 'types';
import type {
  ContentCardItem
} from 'components/cards/content-card/types';

applyTranslations(require('components/cards/content-card/shared/content-card-shared.i18n.json'));

type Props = {
  item: ContentCardItem
};

const SHARED_MSG_KEY = 'content_card_shared';

const getAudienceInfo = (stat?: StatisticsCountry | null): string => {
  if (isNil(stat)) {
    return '-';
  }

  return `${stat.code || ''} (${abbrNum(stat.reach, { decimal: 0 })} | ${Math.round(stat.percent)}%)`;
};

const ContentCardStatsTiktokVideo = ({
  item
}: Props): JSX.Element => {
  const audienceTopCountries = item.metrics?.audienceTopCountries || [];

  return (
    <div className="content-card-stats__section">
      <ContentCardStatsHeader
        type="video"
        date={item.date}
      />
      <ContentCardStatsRow
        type="watch-rate"
        contentType="video"
        metricType="followers"
        value={String(isNil(item.metrics?.watchRate) ? '-' : item.metrics?.watchRate)}
      />
      <ContentCardStatsRow
        type="average-watch-time"
        contentType="video"
        metricType="followers"
        value={`${item.metrics?.avgWatchTimeSec || 0} ${__t(`${SHARED_MSG_KEY}.labels.sec`)}`}
      />
      <ContentCardStatsRow
        type="total-reach"
        contentType="video"
        metricType="followers"
        value={String(getCountMetric(item.metrics?.reach, true))}
      />
      <ContentCardStatsRow
        type="total-reactions"
        contentType="video"
        metricType="followers"
        value={String(getCountMetric(item.metrics?.reactions, true))}
      />
      <ContentCardStatsRow
        type="engagement-rate-followers"
        contentType="video"
        metricType="followers"
        value={String(getRateMetric(item.metrics?.engagementRateFollowers || 0))}
      />
      <ContentCardStatsRow
        type="engagement-rate-views"
        contentType="video"
        metricType="views"
        value={String(getRateMetric(item.metrics?.engagementRateViews || 0))}
      />
      <ContentCardStatsRow
        type="media-value"
        contentType="video"
        metricType="followers"
        value={renderPrice(item.metrics?.mediaValue || 0)}
      />
      {
        !isNil(audienceTopCountries[0]) && (
          <ContentCardStatsRow
            type="audience-country-first"
            contentType="video"
            metricType="followers"
            value={getAudienceInfo(audienceTopCountries[0])}
            hidePopover
          />
        )
      }
      {
        !isNil(audienceTopCountries[1]) && (
          <ContentCardStatsRow
            type="audience-country-second"
            contentType="video"
            metricType="followers"
            value={getAudienceInfo(audienceTopCountries[1])}
            hidePopover
          />
        )
      }
      {
        !isNil(audienceTopCountries[2]) && (
          <ContentCardStatsRow
            type="audience-country-third"
            contentType="video"
            metricType="followers"
            value={getAudienceInfo(audienceTopCountries[2])}
            hidePopover
          />
        )
      }
    </div>
  );
};

export default ContentCardStatsTiktokVideo;
